import React from 'react'

const ProfileShimmer = ({index}) => {
  return (
    <div className="position-relative outer-shimmer px-2" key={`shimmer-${index}`}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
        {/* Circular shimmer image */}
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: '#e0e0e0',
            marginRight: 10,
            animation: 'shimmer 15.5s infinite linear',
            backgroundImage: 'linear-gradient(to right, #e0e0e0 0%, #f5f5f5 50%, #e0e0e0 100%)',
            backgroundSize: '200% 100%',
          }}
        />

        {/* Two-line shimmer title */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              width: '50%',
              height: 10,
              backgroundColor: '#e0e0e0',
              marginBottom: 6,
              borderRadius: 4,
              animation: 'shimmer 15.5s infinite linear',
              backgroundImage: 'linear-gradient(to right, #e0e0e0 0%, #f5f5f5 50%, #e0e0e0 100%)',
              backgroundSize: '200% 100%',
            }}
          />
          <div
            style={{
              width: '90%',
              height: 10,
              backgroundColor: '#e0e0e0',
              borderRadius: 4,
              animation: 'shimmer 15.5s infinite linear',
              backgroundImage: 'linear-gradient(to right, #e0e0e0 0%, #f5f5f5 50%, #e0e0e0 100%)',
              backgroundSize: '200% 100%',
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ProfileShimmer